module.exports = __webpack_public_path__ + "static/media/dealwithitnowparrot.ba52e197.gif";